import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    margin: '30px auto',
    padding: '0 30px',
    maxWidth: '910px'
  },
  loader: {
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '24px'
  },
  imageContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, 283px)',
    justifyContent: 'space-between'
  },
  image: {
    width: '284px',
    height: '148px',
    float: 'left',
    marginBottom: '31px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover'
  },
  colorButton: {
    color: '#ffffff',
    backgroundColor: '#BE1224',
    '&:hover': {
      backgroundColor: '#BE1224'
    },
    '& svg': {
      marginRight: '4px',
      fontSize: '16px'
    }
  }
}));
